// Loaded after app.js
require('./custom.js');
require('./custom/menu.js');
//require('./custom/header.js');
//require('./custom/ui.js');
require('./custom/calculator.js');
require('./custom/stamp.js');
require('./custom/contact.js');
